export const environment = {
  production: true,
  apiURL: 'https://cdcapi.azurewebsites.net/v1_01/',
  apiLocaliTURL: 'https://localitapi.azurewebsites.net/v1_06/',
  paymentTechScript: 'https://www.chasepaymentechhostedpay.com/hpf/js/hpfParent.min.js',
  paymentTechFormUrl: 'https://www.chasepaymentechhostedpay.com/hpf/1_1/',
  sCode: 'rkTl0wgwFkJVxOURkz3tpwWcYols1flS4NdUZAcFzoBAckCxvl6tDr2XE5VGPgfG',
  envName: 'prod',
  port: 8080
};



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/environments/environment.ts